import React from 'react';
import { StyledParagraph } from './Paragraph.styled';
import IParagraph from './types';

const Paragraph: React.FC<IParagraph> = ({ children, ...props }) => (
  <StyledParagraph {...props}>{children}</StyledParagraph>
);

export default Paragraph;
